module.exports = __webpack_public_path__ + "static/media/IMG_2482.418c3d62.jpg";